import { z } from "zod";

import { SqlString } from "../SqlString";

export const sqliteColumnTypeSchema = z.union([
	z.enum(["INTEGER", "REAL", "TEXT", "BLOB", "BOOLEAN", "DATE", "DATETIME"]),
	z.undefined(),
]);
export type SqliteColumnType = z.infer<typeof sqliteColumnTypeSchema>;

export const sqliteColumnDefSchema = z.object({
	name: z.string(),
	type: sqliteColumnTypeSchema,
	nullable: z.boolean().default(true).optional(),
	primaryKey: z.boolean().default(false).optional(),
	unique: z.boolean().default(false).optional(),
	defaultValue: z
		.union([z.string(), z.number(), z.boolean(), z.null(), z.instanceof(SqlString)])
		.optional(),
	references: z
		.object({
			table: z.string(),
			column: z.string(),
		})
		.optional(),
	check: z.string().optional(), // SQL CHECK constraint
});
export type SqliteColumnDef = z.infer<typeof sqliteColumnDefSchema>;

export const sqliteTableDefSchema = z.object({
	tableName: z.string(),
	columns: z.array(sqliteColumnDefSchema),
});

export type SqliteTableDef = z.infer<typeof sqliteTableDefSchema>;
